module.exports = __webpack_public_path__ + "img/陈伟.41e43363.jpg";